import { isPigmentJsonValue } from "./model.js";
function isPortableRecord(value) {
    if (typeof value !== "object" || value === null || Array.isArray(value))
        return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
/**
 * Strictly recognize the complete portable action wire. Unknown envelope keys,
 * untrimmed names, non-record arguments, and non-JSON values all fail closed.
 */
export function isPigmentActionSpec(value) {
    if (!isPortableRecord(value))
        return false;
    if (Object.keys(value).some((key) => key !== "do" && key !== "args"))
        return false;
    if (typeof value.do !== "string" || value.do.length === 0 || value.do !== value.do.trim())
        return false;
    if (value.args === undefined)
        return true;
    return isPortableRecord(value.args) && isPigmentJsonValue(value.args);
}
